<template>
  <donut-page-title
    title="Build Your Journey with AI"
    lucide-icon="Sparkles"
  />
  <div class="f-v f-sb">
    <div ref="topSection" class="f-jc f-as">
      <div class="m-tx4 f-v f-jc f-ac w-80p">
        <div class="t-lg bold">{{ title }}</div>
        <div class="t gray m-bx4">{{ subtitle }}</div>
        <slot name="topSection" />
      </div>
    </div>
    <div ref="bottomSection" class="f-v">
      <slot name="bottomSection" />
      <div class="m-tx4 f-sb f-ac m-bx2">
        <a class="link" :href="backUrl">{{ backText }}</a>
        <div class="f-h f-ac">
          <div class="f-h f-ac">
            <slot name="secondaryAction" />
            <donut-button
              class="m-lx2"
              :disabled="isSaveDisabled"
              :is-loading="state.formSubmitted"
              @click="submitForm"
            >
              Next
              <i class="mi m-lx1">arrow_forward</i>
            </donut-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted, ref } from 'vue';
  import { useStore } from 'vuex';

  const { commit, state } = useStore();
  const emit = defineEmits(['save', 'moveBottomSection']);

  const props = defineProps({
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    isSaveDisabled: { type: Boolean, required: true },
    backUrl: { type: String, required: true },
    backText: { type: String, required: true },
  });
  const bottomSection = ref(null);

  const submitForm = () => {
    emit('save');
  };

  // Keep the bottomSection fixed to the bottom of the screen.
  const moveBottomSection = () => {
    const bottomEl = bottomSection.value;
    if (!bottomEl) return;

    const { left, width } = document.getElementsByTagName('main')[0].getBoundingClientRect();
    bottomEl.style.left = left;
    bottomEl.style.width = width;

    // The body is taller than the screen, so there's no empty space. Just put the bottom section at the
    // bottom of the screen in its natural place.
    if (document.body.getBoundingClientRect().height - window.innerHeight > 1) {
      bottomEl.style.bottom = '';
      bottomEl.style.position = '';
    // If there's empty space, fix the bottom section to the bottom of the screen.
    } else {
      // This banner solution is janky, but otherwise there's an issue where you can't see the bottom buttons
      // when the trial banner is on the page
      bottomEl.style.bottom = state.banner.visible ? '48px' : '0';
      bottomEl.style.position = 'absolute';
    }
    emit('moveBottomSection');
  };

  onMounted(() => {
    window.addEventListener('resize', moveBottomSection);
    window.addEventListener('scroll', moveBottomSection);
    moveBottomSection();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', moveBottomSection);
    window.removeEventListener('scroll', moveBottomSection);
  });
</script>
